// extracted by mini-css-extract-plugin
export default {"bodySize":"App_bodySize__rpsuC","chooseTypeCards":"App_chooseTypeCards__MTB5N"};